module.exports = __webpack_public_path__ + "img/logo.c745c9e2.png";